import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface NavigationState {
  fromComparisonMerge: boolean;
  fromComparisonCancel: boolean;
}

interface NavigationContextType {
  navigationState: NavigationState;
  setFromComparisonMerge: (value: boolean) => void;
  setFromComparisonCancel: (value: boolean) => void;
  resetNavigationState: () => void;
}

const initialState: NavigationState = {
  fromComparisonMerge: false,
  fromComparisonCancel: false,
};

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [navigationState, setNavigationState] = useState<NavigationState>(initialState);

  const setFromComparisonMerge = useCallback((value: boolean) => {
    setNavigationState(prev => {
      const newState = { ...prev, fromComparisonMerge: value };
      return newState;
    });
  }, []);

  const setFromComparisonCancel = useCallback((value: boolean) => {
    setNavigationState(prev => {
      const newState = { ...prev, fromComparisonCancel: value };
      return newState;
    });
  }, []);

  const resetNavigationState = () => {
    setNavigationState(initialState);
  };

  return (
    <NavigationContext.Provider 
      value={{ 
        navigationState, 
        setFromComparisonMerge,
        setFromComparisonCancel,
        resetNavigationState
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = (): NavigationContextType => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}; 